import {configureStore, createSerializableStateInvariantMiddleware} from '@reduxjs/toolkit';
import permissionsReducer from './permissions.reducer';
import userReducer from './user.reducer';
import settingsReducer from './settings.reducer';
import versionsReducer from './versions.reducer';
import surveyReducer from './survey.reducer';
import surveyGraphReducer from "./survey.graph.reducer";
import scheduledCallbackReducer from "./scheduledCallback.reducer";
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";

const store = configureStore({
  reducer: {
    permissions: permissionsReducer,
    authentication: userReducer,
    settings: settingsReducer,
    versions: versionsReducer,
    survey: surveyReducer,
    surveyGraph: surveyGraphReducer,
    scheduledCallbackReducer: scheduledCallbackReducer.reducer
  },
  middleware: () => [createSerializableStateInvariantMiddleware({ isSerializable: (value) => typeof  value !== 'bigint' })]
})

export default store;
export type RootState = ReturnType<typeof store.getState>;

export const useAppDispatch = () => useDispatch<typeof store.dispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
